import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {HttpClientModule} from '@angular/common/http';

import { LoginComponent } from './login/login.component';
import { SecurityService } from './security.service';
import { VendorModule } from '../core/vendor.module';

import { CoreModule } from '../core/core.module';
import { PermissionComponent } from './permission/permission.component';
import { RoleComponent } from './role/role.component';
import { RoleListComponent } from './role/role-list.component';
import { RoleFilterComponent } from './role/role-filter.component';
import { LoguedGuardService } from './logued-guard.service';
import { RoleAddEditComponent } from './role/role-add-edit.component';
import { RoleResolver } from './role/role.resolver';
import { UserComponent } from './user/user.component';
import { UserListComponent } from './user/user-list.component';
import { UserAddEditComponent } from './user/user-add-edit.component';
import { UserResolver } from './user/user.resolver';
import { UserChangePasswordResolver } from './user/user-change-password.resolver';
import { UserChangePasswordComponent } from './user/user-change-password.component';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { PerfilUserResolver } from './user/perfilUser.resolver';
import { UserFotoUploadComponent } from './user/user-foto-upload/user-foto-upload.component';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
  ],
  declarations: [
    LoginComponent,
    PermissionComponent,
    RoleComponent,
    RoleListComponent,
    RoleFilterComponent,
    RoleAddEditComponent,
    UserComponent,
    UserListComponent,
    UserAddEditComponent,
    UserChangePasswordComponent,
    UserFotoUploadComponent
  ],
  exports: [
    LoginComponent,
    PermissionComponent,
    RoleListComponent,
    RoleFilterComponent,
    RoleAddEditComponent,
    UserListComponent,
    UserAddEditComponent,
    UserChangePasswordComponent
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    RoleResolver,
    UserResolver,
    UserChangePasswordResolver,
    PerfilUserResolver
  ]
})
export class SecurityModule { }



// WEBPACK FOOTER //
// ./src/app/security/security.module.ts